var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2115 2.11142C12.4556 1.69593 11.5451 1.69593 10.7893 2.11142L3.73884 5.987C2.91433 6.44023 2.40039 7.31746 2.40039 8.27158V15.7281C2.40039 16.6821 2.91433 17.5594 3.73884 18.0126L10.7893 21.8882C11.5451 22.3037 12.4556 22.3037 13.2115 21.8882L20.2619 18.0126C21.0864 17.5594 21.6004 16.6821 21.6004 15.7281V8.27158C21.6004 7.31746 21.0864 6.44023 20.2619 5.987L13.2115 2.11142ZM11.2756 14.4688V15.894H5.46016V8.21838H11.1364V9.64356H7.18783V11.3105H10.6749V12.6923H7.18783V14.4688H11.2756ZM18.8727 15.8941L16.9952 15.8937L15.5527 13.7538L15.5487 13.754C15.5227 13.755 15.4978 13.7559 15.4718 13.7559H14.0716V12.3415H15.3759C15.912 12.3415 16.3127 12.2226 16.5776 11.9852C16.8416 11.7479 16.9745 11.4276 16.9745 11.0037C16.9745 10.5798 16.842 10.2506 16.5776 10.0167C16.3131 9.78283 15.9124 9.66587 15.3759 9.66587H14.0716V8.21848H15.4718C16.1436 8.21848 16.7231 8.32952 17.21 8.55306C17.697 8.77612 18.0721 9.0954 18.337 9.5124C18.602 9.92889 18.7339 10.4337 18.7339 11.0037C18.7339 11.5737 18.6014 12.0652 18.337 12.4782C18.0721 12.8913 17.6964 13.2072 17.21 13.4267L17.2061 13.4285L17.2039 13.4294L17.2019 13.4302L17.1988 13.4314L17.1951 13.4331L18.8727 15.8941ZM11.7673 8.21848H13.4411V15.8941H11.7673V8.21848Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErp);
export default __webpack_public_path__ + "static/media/erp.453558ebf101029a4c54eb8ebed1f8db.svg";
export { ForwardRef as ReactComponent };